import axios from '@/lib/AxApi';

export default
{
    getDentalSolutionCompanies(params, cb)
    {
        params.type = 'dentalsolutions';
        axios.get('/rest/User_companies/selectRow',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
}


// WEBPACK FOOTER //
// ./src/api/dentalsolutioncompanies.js